<template>
    <div class="loading">
        <div class="loadingBox">
            <div class="loadings loading1"></div>
            <div class="loadings loading2"></div>
            <div class="loadings loading3"></div>
            <div class="loadings loading4"></div>
        </div>
        <div class="loadingBox">
            <div class="loadings loading5"></div>
            <div class="loadings loading6"></div>
            <div class="loadings loading7"></div>
            <div class="loadings loading8"></div>
        </div>
        <div class="loadingBox">
            <div class="loadings loading9"></div>
            <div class="loadings loading10"></div>
            <div class="loadings loading11"></div>
            <div class="loadings loading12"></div>
        </div>
        <div class="loading_text">Loading</div>
    </div>
</template>

<script>
export default {
  name: 'loading'
}
</script>

<style scoped>
.loading {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1040;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    outline: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(12, 34, 67, 0.4);
}
.loading .loadingBox:nth-child(2){
    transform: rotate(30deg);
}
.loading .loadingBox:nth-child(3){
    transform: rotate(60deg);
}

@media (max-width: 750px) {
    .loading_text{
        color: rgb(248, 182, 45);
        font-size: 0.7rem;
        font-weight: bold;
        position: fixed;
        top: 50%;
        text-align: center;
        width: 100%;
        margin-top: -1.5rem;
    }
    .loadingBox{
        height: 4rem;
        width: 4rem;
        position: fixed;
        left: 50%;
        top: 50%;
        margin-top: -3rem;
        margin-left: -2rem;
    }
    .loadings{
        height: 0.3rem;
        width: 0.3rem;
        background: rgba(248, 182, 45, 0.9);
        position: absolute;
        border-radius: 50%;
    }
}
@media (min-width: 750px) {
    .loading_text{
        color: rgb(248, 182, 45);
        font-size: 35px;
        font-weight: bold;
        position: fixed;
        top: 50%;
        text-align: center;
        width: 100%;
        margin-top: -27px;
    }
    .loadingBox{
        height: 200px;
        width: 200px;
        position: fixed;
        left: 50%;
        top: 50%;
        margin-top: -100px;
        margin-left: -100px;
    }
    .loadings{
        height: 15px;
        width: 15px;
        background: rgba(248, 182, 45, 0.9);
        position: absolute;
        border-radius: 50%;
    }
}
.loadingBox .loadings:nth-child(1){
    left: 0;
    top: 0;
}
.loadingBox .loadings:nth-child(2){
    right: 0;
    top: 0;
}
.loadingBox .loadings:nth-child(3){
    right: 0;
    bottom: 0;
}
.loadingBox .loadings:nth-child(4){
    left: 0;
    bottom: 0;
}
.loading1{
    -webkit-animation: loads 1.2s linear infinite;
    animation: loads 1.2s linear infinite;
}
.loading5{
    -webkit-animation: loads 1.2s linear 0.1s infinite;
    animation: loads 1.2s linear 0.1s infinite;
}
.loading9{
    -webkit-animation: loads 1.2s linear 0.2s infinite;
    animation: loads 1.2s linear 0.2s infinite;
}
.loading2{
    -webkit-animation: loads 1.2s linear 0.3s infinite;
    animation: loads 1.2s linear 0.3s infinite;
}
.loading6{
    -webkit-animation: loads 1.2s linear 0.4s infinite;
    animation: loads 1.2s linear 0.4s infinite;
}
.loading10{
    -webkit-animation: loads 1.2s linear 0.5s infinite;
    animation: loads 1.2s linear 0.5s infinite;
}
.loading3{
    -webkit-animation: loads 1.2s linear 0.6s infinite;
    animation: loads 1.2s linear 0.6s infinite;
}
.loading7{
    -webkit-animation: loads 1.2s linear 0.7s infinite;
    animation: loads 1.2s linear 0.7s infinite;
}
.loading11{
    -webkit-animation: loads 1.2s linear 0.8s infinite;
    animation: loads 1.2s linear 0.8s infinite;
}
.loading4{
    -webkit-animation: loads 1.2s linear 0.9s infinite;
    animation: loads 1.2s linear 0.9s infinite;
}
.loading8{
    -webkit-animation: loads 1.2s linear 1s infinite;
    animation: loads 1.2s linear 1s infinite;
}
.loading12{
    -webkit-animation: loads 1.2s linear 1.1s infinite;
    animation: loads 1.2s linear 1.1s infinite;
}
@-webkit-keyframes loads {
    0%,80%,100%{
        transform: scale(0.0);
        -webkit-transform: scale(0.0);
    }
    40%{
        transform: scale(2.0);
        -webkit-transform: scale(2.0);
    }
}
@keyframes loads {
    0%,80%,100%{
        transform: scale(0.0);
        -webkit-transform: scale(0.0);
    }
    40%{
        transform: scale(2.0);
        -webkit-transform: scale(2.0);
    }
}
</style>